import React from "react";
import { Buttton, Cards, Modaal } from "..";
import { Col, Row } from "react-bootstrap";
import { PiAsclepius, PiCalendar, PiClock, PiUserCircle } from "react-icons/pi";
import { useSelector } from "react-redux";
import { SlLocationPin } from "react-icons/sl";
import { LuEuro } from "react-icons/lu";
import { useTranslation } from "react-i18next";

const PatientDetailsModal = ({
    show,
    onHide,
    loginData,
    setShowModal3,
    setShowModal2,
    setSelectedAppointmentGuid,
    chatAppointmentDetails,
    emergencyCall,
}) => {
    const { t } = useTranslation();

    const postBookedAppointmentData = useSelector(
        (state) => state.patient.postBookedAppointmentData?.data
    );
    const getBookedChatDetailsData = useSelector(
        (state) => state.patient.getBookedChatDetailsData?.data
    );
    const postBookedEmergencyAppointmentData = useSelector(
        (state) => state.doctor.postBookedEmergencyAppointmentData?.data
    );

    const data = emergencyCall
        ? postBookedEmergencyAppointmentData?.result
        : chatAppointmentDetails
            ? getBookedChatDetailsData?.result
            : postBookedAppointmentData?.result;

    return (
        <Modaal.Modaal
            show={show}
            onHide={onHide}
            size="xl"
            centered="true"
            title={
                <h2 className="exado-title-nine">
                    {t("patient_details_for")}{" "}
                    {data?.patientFirstName && data?.patientLastName
                        ? `${data.patientFirstName} ${data.patientLastName}`
                        : data?.patientName}
                </h2>
            }
            bodyContent={
                <>
                    <Row className="">
                        <Col className="pcard-col">
                            <Cards.Cardd
                                className="cardd"
                                header={t("appointment_time")}
                                content={
                                    <ul className="cardd-app-ul">
                                        <li className="cardd-app-li exado-title-six">
                                            <PiUserCircle className="list-icon" />{" "}
                                            {data?.patientFirstName || data?.patientLastName
                                                ? `${data?.patientFirstName ?? ""} ${data?.patientLastName ?? ""
                                                    }`.trim()
                                                : data?.patientName}
                                        </li>
                                        <li className="cardd-app-li exado-title-six">
                                            <PiClock className="list-icon" />
                                            {new Date(data?.appointmentDateTime).toLocaleTimeString(
                                                "en-US",
                                                {
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                    hour12: true,
                                                }
                                            )}
                                        </li>
                                        <li className="cardd-app-li exado-title-six">
                                            <PiCalendar className="list-icon" />{" "}
                                            {
                                                new Date(data?.appointmentDateTime).toLocaleDateString(
                                                    "en-GB",
                                                    {
                                                        weekday: "long",
                                                        day: "2-digit",
                                                        month: "long",
                                                        year: "numeric",
                                                    }
                                                )
                                                // .replace(/\//g, " - ")
                                            }
                                        </li>
                                    </ul>
                                }
                                footer={<></>}
                            />
                        </Col>
                        <Col className="pcard-col">
                            <Cards.Cardd
                                className="cardd"
                                header={t("appointment_detail")}
                                content={
                                    <>
                                        <ul className="cardd-app-ul">
                                            <li className="cardd-app-li exado-title-six">
                                                <PiAsclepius className="list-icon" />
                                                {data?.physicianServices || data?.medicalSpeciality}
                                            </li>
                                            <li className="cardd-app-li exado-title-six">
                                                <SlLocationPin className="list-icon" />
                                                {data?.appointmentType}
                                            </li>
                                            <li className="cardd-app-li exado-title-six">
                                                <LuEuro className="list-icon" />
                                                {data?.amount} {data?.appointmentCurrency}
                                            </li>
                                        </ul>
                                    </>
                                }
                                footer={<></>}
                            />
                        </Col>
                    </Row>
                    <Row className="exado-sub-row1">
                        <Col className="exado-col-pd">
                            <ul className="pd-ul">
                                <li className="pd-li">
                                    <div className="blkIcon">Q</div>
                                    <span className="exado-title-seven">
                                        {t("patient_Details.since_when_symptoms_are_active")}
                                    </span>
                                </li>
                                <li className="pd-li">
                                    <div className="blkIcon">A</div>
                                    <p className="exado-title-six">{data?.sinceWhen}</p>
                                </li>
                                <li className="pd-li">
                                    <div className="blkIcon">Q</div>
                                    <span className="exado-title-seven">
                                        {t("patient_Details.is_any_medication_or_treatment_taken")}
                                    </span>
                                </li>
                                <li className="pd-li">
                                    <div className="blkIcon">A</div>
                                    <p className="exado-title-six">{data?.anyMedication}</p>
                                </li>
                                <li className="pd-li">
                                    <div className="blkIcon">Q</div>
                                    <span className="exado-title-seven">
                                        {t("patient_Details.has_diagnosis_been_given")}
                                    </span>
                                </li>
                                <li className="pd-li">
                                    <div className="blkIcon">A</div>
                                    <p className="exado-title-six">{data?.diagnosisGiven}</p>
                                </li>
                                <li className="pd-li">
                                    <div className="blkIcon">Q</div>
                                    <span className="exado-title-seven">
                                        {t("patient_Details.describe_problem_or_symptoms")}
                                    </span>
                                </li>
                                <li className="pd-li">
                                    <div className="blkIcon">A</div>
                                    <p className="exado-title-six">{data?.symptoms}</p>
                                </li>
                            </ul>
                        </Col>
                    </Row>
                </>
            }
            footer={
                !chatAppointmentDetails &&
                !emergencyCall && (
                    <Buttton.Buttton
                        children={t("cancel_appointment")}
                        className="btn-solid-Aqua_Teal"
                        onClick={() => {
                            setShowModal3(true);
                            setShowModal2(false);
                            setSelectedAppointmentGuid(data?.appointmentGuid);
                        }}
                    />
                )
            }
            backdrop="static"
            className="input-modal aap-details-modal"
        />
    );
};

export default PatientDetailsModal;
